<script lang="ts">
  import { onDestroy, onMount } from 'svelte';

  import { recaptchaLoaded, recaptchaModel } from '../model';

  export let value: string | null = '';
  export let name: string;
  export let containerId: string;
  export let error: string | undefined = undefined;

  $: value = $recaptchaModel[containerId] || '';

  $: if ($recaptchaLoaded) {
    recaptchaModel.initRecaptchaContainer(containerId);
  }

  onMount(() => {
    recaptchaModel.initRecaptchaScript();
  });

  onDestroy(() => {
    recaptchaModel.destroyRecaptchaWidget(containerId);
  });
</script>

<div>
  <input type="hidden" {name} {value} />

  <div id="{containerId}"></div>

  {#if error}
    <p class="mt-2 text-sm text-red-500 first-letter:capitalize">
      {error}
    </p>
  {/if}
</div>
